import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Carousel.css";

const Carousel = () => {
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);

  const endpoints = [
    { path: "/about", img: "../images/aboutUs.webp", label: "About Us" },
    { path: "/blog", img: "../images/blog.webp", label: "Blog" },
    { path: "/books", img: "../images/books.webp", label: "Books" },
    {
      path: "/information",
      img: "../images/information.webp",
      label: "Information",
    },
  ];

  const next = () => {
    setIndex((current) => (current + 1) % endpoints.length);
  };

  const prev = () => {
    setIndex((current) => (current - 1 + endpoints.length) % endpoints.length);
  };

  const leftIndex = (index - 1 + endpoints.length) % endpoints.length;
  const centerIndex = index % endpoints.length;
  const rightIndex = (index + 1) % endpoints.length;

  return (
    <div className="carousel-container">
      <button className="left-button" onClick={prev}>
        &lt;
      </button>
      <div className="carousel">
        <div
          className="carousel-item"
          onClick={() => navigate(endpoints[leftIndex].path)}
        >
          <img
            src={endpoints[leftIndex].img}
            alt={endpoints[leftIndex].label}
          />
          <p>{endpoints[leftIndex].label}</p>
        </div>
        <div
          className="carousel-item"
          onClick={() => navigate(endpoints[centerIndex].path)}
        >
          <img
            src={endpoints[centerIndex].img}
            alt={endpoints[centerIndex].label}
          />
          <p>{endpoints[centerIndex].label}</p>
        </div>
        <div
          className="carousel-item"
          onClick={() => navigate(endpoints[rightIndex].path)}
        >
          <img
            src={endpoints[rightIndex].img}
            alt={endpoints[rightIndex].label}
          />
          <p>{endpoints[rightIndex].label}</p>
        </div>
      </div>
      <button className="right-button" onClick={next}>
        &gt;
      </button>
    </div>
  );
};

export default Carousel;
